import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { supabase, Caregiver } from '../lib/supabase';

export function useCaregiver() {
  const { user } = useAuth();
  const [caregiver, setCaregiver] = useState<Caregiver | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      setCaregiver(null);
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);

    supabase
      .from('caregivers')
      .select('*')
      .eq('id', user.id)
      .single()
      .then(({ data, error }) => {
        if (cancelled) return;
        if (error) {
          console.warn('[useCaregiver] Fetch error:', error);
          setCaregiver(null);
        } else {
          setCaregiver(data as Caregiver);
        }
        setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [user]);

  return { caregiver, loading };
}
